import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./PickupDetails.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.PICKUP_DETAILS),
  name: SitesRouteNames.SITE_PICKUP_DETAILS,
  component: Component,
} as RouteRecordRaw;
